// ============================================================================
// Roof Designer (Stufe 1) · RoofDesignerPage — projektgebundene Route
// ----------------------------------------------------------------------------
// Vollflächige Dachplaner-Ansicht unter /projects/:id/roof-designer. Lädt den
// Projektnamen best-effort (Breadcrumb) und rendert die Workspace-Komposition.
// ============================================================================
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { apiClient } from "@/lib/api-client.js";
import { RoofDesignerWorkspace } from "./RoofDesignerWorkspace.js";

export function RoofDesignerPage() {
  const { id } = useParams<{ id: string }>();
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!id) return;
    void (async () => {
      const res = await apiClient.get<{ name: string }>(`/projects/${id}`);
      if (res.success) setName(res.data.name);
    })();
  }, [id]);

  return (
    <div>
      <div style={{ fontSize: 13, color: "var(--color-text-muted)", marginBottom: 8 }}>
        <Link to="/projects" style={{ color: "var(--color-text-muted)" }}>
          Projekte
        </Link>{" "}
        →{" "}
        {id ? (
          <Link to={`/projects/${id}`} style={{ color: "var(--color-text-muted)" }}>
            {name ?? "Projekt"}
          </Link>
        ) : (
          "Projekt"
        )}{" "}
        → Dachplaner
      </div>

      <div className="page-header">
        <div>
          <h1 className="page-title">
            Dachplaner{" "}
            <span
              style={{
                fontSize: 12,
                fontWeight: 600,
                color: "var(--color-info)",
                background: "var(--color-info-tint)",
                padding: "2px 8px",
                borderRadius: 999,
                marginLeft: 8,
                verticalAlign: "middle",
              }}
            >
              Stufe 1 · Entwurf
            </span>
          </h1>
          <div style={{ fontSize: 13, color: "var(--color-text-muted)", marginTop: 4 }}>
            Dach manuell abzeichnen, Maßstab setzen, Module belegen und kWp berechnen — ohne automatische
            technische Freigabe.
          </div>
        </div>
        {id && (
          <Link to={`/projects/${id}`} className="btn-secondary" style={{ fontSize: 13 }}>
            Zurück zum Projekt
          </Link>
        )}
      </div>

      <RoofDesignerWorkspace {...(id ? { projectId: id } : {})} />
    </div>
  );
}
